<template>
  <div v-if="materials.length" class="session-content-block">
    <div class="session-content-block__data">
      <ul class="material-list">
        <li
          v-for="(material, materialIndex) in materials"
          @click="$emit('open', material.id)"
          :key="`material-${materialIndex}`"
        >
          <div class="material-item-icon">
            <i :class="`fa-regular ${material.fa_icon}`"></i>
          </div>

          <div class="material-item-content">
            <div class="material-item-title">{{ material.title }}</div>
            <div v-if="material.comments" class="material-item-comments">
              {{ material.comments }}
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ['materials'],
}
</script>


<style lang="scss" scoped>
.material-list {
  list-style: none;
  padding-left: 0;

  .material-item-icon {
    background: linear-gradient(320deg, rgba(217, 240, 255, 1) 22%, rgba(226, 240, 250, 0.67) 100%);
    border-radius: var(--attendee-card-border-radius);
    height: 40px;
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      color: #4f6585;
    }
  }

  .material-item-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
  }

  .material-item-title {
    font-size: 16px;
  }

  .material-item-comments {
    font-size: 12px;
    color: #6b7280;
    line-height: 1.2;
  }

  li {
    margin-bottom: var(--attendee-gap-md);
    list-style: none;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
    gap: var(--attendee-gap-md);
    cursor: pointer;
  }
}
</style>
